module.exports = __webpack_public_path__ + "static/img/guoqi3.222a42e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guoqi3.png
// module id = xZ9U
// module chunks = 1